// test2204
(2204 && 0);
